/**
 * Minimum, maximum permissible number of selections.
 * @type {Object}
 */
export const VALIDATION_THRESHOLD = {
	MIN: 1,
	MAX: 200,
};

/**
 * Visible headers used for output, selection table rendering.
 * @type {string[]}
 */
export const ADMIN_HEADERS = [
	'Name',
	'Network ID',
	'Job Title',
	'Department',
	'UPMC E-Sign-On ID',
	'Manager',
];

export const IDENTIFIER_TYPES = {
	EMAIL: 'Email',
	EMPLOYEE_ID: 'Employee ID',
	'UPMC_E-SIGN-ON_ID': 'UPMC E-Sign-On ID',
	NETWORK_ID: 'Network ID',
};
